import { useState, useEffect } from 'react';
import './style.common.scss';
import BarChart from 'app/shared/BarChart';
// import { Table } from '@intellicar/phoenix-design-system';
import Table from 'app/shared/Table';
import { JSONTOCSV } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import moment from 'moment';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import SearchBox from 'app/shared/SearchBox';
function ChargeUtilization(props) {
	const [activeTab, setActiveTab] = useState(0);
	const [activeChartView, setActiveChartView] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');

	useEffect(() => {}, [props.data]);
	useEffect(() => {
		setActiveTab(0);
	}, [props.isLive]);

	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Charge_Utilization_' + date;
	};

	const processTableHeader = () => {
		let processed = [];
		for (let idx in props.heads) {
			processed.push({
				title: props.heads[idx].heading,
				key: props.heads[idx].key,
				sortable: true,
				dataIndex: props.heads[idx].key,
				align: props.heads[idx].key === 'vehicleno' ? 'left' : 'right',
			});
		}
		return processed;
	};
	const processTableData = () => {
		return props.data.history.map((item, index) => ({
			...item,
			key: index,
		}));
	};
	const processChartData = () => {
		let data = props.data.distribution[activeChartView === 0 ? 'chargeused' : 'distance'];
		let entries = Object.entries(data);
		let finalData = [];
		for (let idx in entries) {
			finalData.push({
				range: entries[idx][1][0] + (activeChartView === 0 ? '%' : ' Km'),
				value: entries[idx][1][1],
			});
		}
		return finalData;
	};

	const searchTable = (key) => {
		if (key.length < 3) return;
		setSearchQuery(key);
	};

	const renderWidgetControl = () => {
		return (
			<div
				className="WidgetControl"
				style={{
					justifyContent: 'space-between',
					flexDirection: openModal ? 'row' : 'row',
				}}
			>
				{activeTab === 1 ? (
					<div className="SearchControl">
						<SearchBox placeholder={'Search'} onSearch={searchTable} rounded />
					</div>
				) : null}
				{activeTab === 0 ? (
					<div className="WidgetTab">
						<ul>
							<li
								onClick={() => setActiveChartView(0)}
								className={activeChartView === 0 ? 'active' : ''}
							>
								Charge Used
							</li>
							<li
								onClick={() => setActiveChartView(1)}
								className={activeChartView === 1 ? 'active' : ''}
							>
								Distance
							</li>
						</ul>
					</div>
				) : null}
				<div className="WidgetTab">
					<ul>
						<li onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
							Chart
						</li>
						<li onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
							Table
						</li>
					</ul>
				</div>
			</div>
		);
	};
	const renderView = () => {
		return activeTab === 0 ? (
			<div className="GraphView">
				<BarChart
					data={processChartData() || []}
					color={['#E9445F']}
					axisLegends={{
						left: 'No of vehicles',
						bottom: activeChartView === 0 ? 'Charge used' : 'Distance',
					}}
				/>
			</div>
		) : (
			<div className="tableView">
				<Table
					columns={processTableHeader()}
					dataSource={processTableData()}
					searchQuery={searchQuery}
					searchKey={'vehicleno'}
					striped
					slim
					modal={openModal}
				/>
			</div>
		);
	};
	return (
		<div className="WidgetContainer">
			<div className="WidgetHeader">
				<div className="Title">Charge Utilization</div>
				<div className="RightControl">
					<DownloadIcon
						onClick={() => JSONTOCSV(processTableData(), processTableHeader(), getCSVName())}
						style={{ marginRight: 14, cursor: 'pointer' }}
					/>
					<ExpandIcon style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
				</div>
			</div>
			<div className="WidgetContent">
				{renderWidgetControl()}
				<div className="ContentContainer">{renderView()}</div>
			</div>

			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<span onClick={() => setOpenModal(false)} className="close">
							&times;
						</span>
					</div>
					<span
						className="mh-download"
						style={{ position: 'relative', top: '0.5rem', float: 'right' }}
					>
						<DownloadIcon
							onClick={() => JSONTOCSV(processTableData(), processTableHeader(), getCSVName())}
							style={{ marginRight: 14, cursor: 'pointer' }}
						/>
					</span>
					<div
						className="Title"
						style={{ fontWeight: 500, position: 'relative', top: '5px', width: '500px' }}
					>
						Charge Utilization
					</div>
					<div className="ModalContainer">
						{renderWidgetControl()}

						<div className="WidgetView" style={{ height: '80%' }}>
							{renderView()}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChargeUtilization;
